import { Tag } from '@components/tag';
import { useScopedTranslate } from '@locale/translate';

import { TravellerJourneyAction } from 'api/types';
import { MoreItems, TravellerNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { useFlowNodes } from 'ui/traveller-journey-builder/hooks/use-nodes';
import { NodeActions } from 'ui/traveller-journey-builder/node-types/common';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

import { descriptionLocale } from './journey-node';

import { useConditionDescription } from '../condition-v2/hooks';
import { getConditionDescription, getConditionTooltip } from '../condition/journey-node';

type ActionType = 'break_loop';

export const getDescription = (action: TravellerJourneyAction<ActionType>): string => {
  return getConditionDescription({
    values: action.values,
    styled: false,
    locale: descriptionLocale,
  });
};

export const Node = (node: TravellerJourneyNode<ActionType>) => {
  const { t } = useScopedTranslate(nodeLocale);
  useFlowNodes();

  const values = node.data?.values;
  const { descriptionText, isTextClamped } = useConditionDescription(values, descriptionLocale);

  return (
    <NodeContainer node={node}>
      <TravellerNodeActionCard
        node={node}
        label={t('title')}
        descriptionText={descriptionText}
        tooltip={getConditionTooltip({ values, isTextClamped, locale: descriptionLocale })}
        renderBelowDescription={
          <>
            <MoreItems items={values?.conditions} />
            {node.data.isHalted && (
              <Tag size="small" text={t('conditionNotMet')} variant="purple" />
            )}
          </>
        }
      >
        <NodeActions node={node} />
      </TravellerNodeActionCard>
    </NodeContainer>
  );
};

const nodeLocale = {
  en: {
    title: 'Exit loop',
    conditionNotMet: 'Condition not met',
  },
};
